module.exports = __webpack_public_path__ + "img/SUPEROK_2.af7a0c3e.jpg";